// extracted by mini-css-extract-plugin
export default {"subtitleShell":"SetupProgressCard_subtitleShell__XeXmz","subtitle":"SetupProgressCard_subtitle__LZseI"};